(function(){
    "use strict";
    
    angular
        .module("app")
        .component("productClass", { // product-class
            templateUrl: "src/app/productClass/productClass.html",
            controller: controller
        });

    function controller($routeParams, session, CART_TYPE_CODE) {
        const $ctrl = this;
        $ctrl.productClass = $routeParams.classId;


        $ctrl.$onInit = () => {
            //const classId = $routeParams.classId;
            //const classification = session.classifications.find(c => c.class_id.toString() === classId);
            //$ctrl.className = classification ? classification.class_name : "Unknown";

            ////session.products.getClassification(classId)
            ////    .then(classification => {
            ////        $ctrl.className = classification ? classification.class_name : "Unknown";
            ////    });
            //session.products.searchCriteria.searchText = "";
            //session.products.searchCriteria.classId = classId;
            //session.products.searchAll();
        };

        //$ctrl.productSelected = cartTypeCode => {
        //    session
        //        .setCartType(cartTypeCode)
        //        .then(() => {
        //            session.products.searchCriteria.searchText = "";
        //            session.gotoProductSearch();
        //        });
        //};
    }
    controller.$inject = ["$routeParams", "sessionService", "CART_TYPE_CODE"];
    
})()